import { render, staticRenderFns } from "./PlayerFire.vue?vue&type=template&id=5410b253&"
import script from "./PlayerFire.vue?vue&type=script&lang=js&"
export * from "./PlayerFire.vue?vue&type=script&lang=js&"
import style0 from "./PlayerFire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports